import { Component, OnInit, HostListener, ViewChild, Output, Input, ElementRef, EventEmitter } from '@angular/core';
import { ThemeService } from '../theme.service';
import { BaseComponent } from '../classes/BaseComponent';
import { StringHelper } from '../helpers/StringHelper';
import { Global } from '../classes/Global';
import { PriceHelper } from '../helpers/PriceHelper';

@Component({
  selector: 'app-slider-multichoice',
  templateUrl: './slider-multichoice.component.html',
  styleUrls: ['./slider-multichoice.component.scss']
})
export class SliderMultichoiceComponent extends BaseComponent implements OnInit {

  @Input() title = "";
  @Input() label = "";
  @Input() right: boolean = false;
  @Input() isPrice: boolean = false;
  @Input() constMinValue: number = 0;
  @Input() constMaxValue: number = 50;
  @Input() alignLeft: boolean = false;

  // list of the items already selected
  //@Input() selectedItemsList: Array<CustomMap> = [];

  private _selectedItemsList: Array<CustomMap> = [];

  @Input() set selectedItemsList(value: Array<CustomMap>) {
    this._selectedItemsList = value;
    if(this._selectedItemsList && this._selectedItemsList[0]) {
      this.chooseItem(this._selectedItemsList[0]);
    }
  }

  get selectedItemsList(): Array<CustomMap> {
    return this._selectedItemsList;
  }

  _itemList: CustomMap[] = [];
  // list of all the items, including the selected
  @Input() set itemList(value: CustomMap[]) {
    this._itemList = value;
    this.update();
  }

  getitemList(): CustomMap[] {
    return this._itemList;
  }

  @Output() selectionChanged = new EventEmitter();

  public elementRef;
  @ViewChild('dropdownContent', {static: false}) dropdownContent;
  @ViewChild('rangeSlider', {static: false}) rangeSlider;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.closeDropdown();
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  minValue: number = 0;
  maxValue: number = 0;

  constructor(
    myElement: ElementRef,
    private themeService: ThemeService
  ) {
    super();
    this.elementRef = myElement;
  }

  ngOnInit() {
    this.update();
  }

  update() {
    this.setMax();
    if(this.selectedItemsList) {
      this.chooseItem(this.selectedItemsList[0]);
    }
  }

  setMax() {
    let max = 0;
    for(let item of this._itemList){
      if(item && item.key[0] == 'o') { // over
        max = parseFloat(item.key.split('o')[1]);
      }
    }
    this.constMaxValue = max * 2;
  }

  shouldBeRed(): boolean {
    return this.selectedItemsList && this.selectedItemsList[0] && this.selectedItemsList[0].key != "all";
  }

  isSelected(item): boolean {
    if(!item) { return false; }
    return this.selectedItemsList && this.selectedItemsList[0] && this.selectedItemsList[0].key == item.key;
  }

  isOpen(): boolean {
    return this.dropdownContent && this.dropdownContent.nativeElement && this.dropdownContent.nativeElement.classList.contains("dd-open");
  }

  dropdownClick() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      if (this.isOpen()) {
        this.closeDropdown();
      }
      else {
        this.openDropdown();
      }
    }
  }

  openDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-open";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  closeDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-close";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  getSelection(): string {

    if(!this.selectedItemsList) {
      return "";
    }

    const selection = [];
    for (const item of this.selectedItemsList) {
        selection.push(item.value);
    }
    const selectionString = selection.join();
    let returnValue = selectionString.substr(0, 8);
    const restLength = selectionString.length - 8;
    if (restLength > 11) {
    returnValue += "..." + selectionString.substr(-8);
    }
    else {
        returnValue += selectionString.substr(8);
    }
    return returnValue;
  }

  reset() {
    this.minValue = this.constMinValue;
    this.maxValue = this.constMaxValue;
    if(this.rangeSlider) {
      this.rangeSlider.minValue = this.minValue;
      this.rangeSlider.maxValue = this.maxValue;
    }

    this.selectionChanged.emit([{key: "all", value: this.getString('all')}]);
  }

  chooseItem(item) {

    if(!item || !item.key) {
      return;
    }

    if(item.key == 'all') {
      this.minValue = this.constMinValue;
      this.maxValue = this.constMaxValue;
    }
    else if(item.key[0] == 'o') { // over
      this.minValue = parseFloat(item.key.split('o')[1]);
      this.maxValue = this.constMaxValue;
    }
    else if(item.key[0] == 'u') { // under
      this.minValue = this.constMinValue;
      this.maxValue = parseFloat(item.key.split('u')[1]);
    }
    else if(item.key.indexOf('-') > 0) { //between
      this.minValue = parseFloat(item.key.split('-')[0]);
      this.maxValue = parseFloat(item.key.split('-')[1]);
    }
    else { // exact value
      this.minValue = parseFloat(item.key);
      this.maxValue = parseFloat(item.key);
    }

    //update the slider
    if(this.rangeSlider) {
      this.rangeSlider.minValue = this.minValue;
      this.rangeSlider.maxValue = this.maxValue;
    }

    this.selectionChanged.emit([item]);

  }

  rangeSliderChange(values) {
    if(values.min == null || values.max == null) {
      return;
    }
    let key = "";
    let value = "";
    if(values.min == this.constMinValue && values.max == this.constMaxValue) {
      key = "all";
      value = this.getString('all');
    }
    else if (values.min == this.constMinValue) {
      key = 'u' + values.max.toFixed(2);
      value = StringHelper.format(this.getString("priceRange_under"), PriceHelper.formatPrice(values.max,
      Global.countries[Global.getCountry()].currency, true, true, false));
    }
    else if (values.max == this.constMaxValue) {
      key = 'o' + values.min.toFixed(2);
      value = StringHelper.format(this.getString("priceRange_over"), PriceHelper.formatPrice(values.min,
      Global.countries[Global.getCountry()].currency, true, true, false));
    }
    else {
      key = values.min.toFixed(2) + '-' + values.max.toFixed(2);
      value = StringHelper.format(this.getString("priceRange_between"),
      PriceHelper.formatPrice(values.min, Global.countries[Global.getCountry()].currency, true, true, false),
      PriceHelper.formatPrice(values.max, Global.countries[Global.getCountry()].currency, true, true, false));
    }

    this.selectionChanged.emit([{key: key, value: value}]);

  }

}

export class CustomMap {
  key: string;
  value: string;
}
